import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaintKittsAndNevis = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_364_1826)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1.6015 17.9992C2.36139 19.359 3.36125 20.4788 4.52109 21.3987L23.8784 10.2403C23.6384 8.80045 23.1585 7.36065 22.3986 6.00084C21.6387 4.64103 20.6388 3.52119 19.479 2.60132L0.121704 13.7598C0.361671 15.2396 0.841604 16.6394 1.6015 17.9992Z",
				fill: "#3E4347"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.84079 22.8385L23.9584 12.9599C24.0384 12.04 23.9984 11.1601 23.8784 10.2402L4.52112 21.3987C5.24102 21.9586 6.04091 22.4385 6.84079 22.8385Z",
				fill: "#FFE62E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.121726 13.7598L19.479 2.60136C18.7591 2.04144 17.9992 1.5615 17.1593 1.16156L0.041737 11.0402C-0.0382518 11.9601 0.00174259 12.8799 0.121726 13.7598Z",
				fill: "#FFE62E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.1592 1.16151C13.7197 -0.478264 9.5603 -0.43827 6.00079 1.60144C2.44129 3.64116 0.361581 7.24066 0.041626 11.0401L17.1592 1.16151Z",
				fill: "#699635"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.8407 22.8385C10.2802 24.4783 14.4396 24.4383 17.9991 22.3986C21.5586 20.3589 23.6384 16.7594 23.9583 12.9599L6.8407 22.8385Z",
				fill: "#ED4C5C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.0006 15.2396L9.84035 15.4795L8.44054 14.1997L9.16044 12.48L7.56066 13.3998L6.16086 12.08L6.6008 13.9598L5.04102 14.8396L6.84076 15.1196L7.2807 16.9593L8.0006 15.2396Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.7993 10.1603L18.6391 10.4003L17.2392 9.08044L17.9591 7.40068L16.3994 8.28055L14.9996 7.00073L15.3995 8.84048L13.8397 9.76035L15.6795 10.0003L16.1194 11.8401L16.7993 10.1603Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_364_1826",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSaintKittsAndNevis;
